export interface cv_CompatibilityAccessLevel {
    C_CompatibilityAccessLevel_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CompatibilityAccessLevel: string;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
